// Exports
export default {
	"popover": "popover_9k04O",
	"callInfo": "callInfo_ob3yC",
	"copyLinkOrPhone": "copyLinkOrPhone_xU8+6",
	"row": "row_P3b3W",
	"link": "link_xhP0X",
	"copyIcon": "copyIcon_Zjli5",
	"additionalNumber": "additionalNumber_j47Xd",
	"close": "close_htlSe",
	"inviteOrCopyFooter": "inviteOrCopyFooter_JrqOk"
};
